import { Modal as AntModal, Badge, Calendar } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import "../../../src/styles/HolidayEventStyle.css";
import ClientNavbarLayout from "../../components/navbar/ClientNavbarLayout";

const HolidayCalender = () => {
  const [holidayData, setHolidayData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const base_url = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    // Fetch holiday data from your API
    const fetchHolidayData = async () => {
      try {
        const authHeader = sessionStorage.getItem("accessToken");
        const response = await axios.get(
          `${base_url}/api/v1/client/holiday/getholidays`,
          {
            headers: { Authorization: `Bearer ${authHeader}` },
          }
        );

        const { data } = response;
        // console.log(data);
        setHolidayData(data.data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchHolidayData();
  }, []);

  const getListData = (value) => {
    const date = value.format("YYYY-MM-DD");

    // Ensure that holidayData is an array before filtering
    if (!Array.isArray(holidayData)) {
      return [];
    }

    const matchingHolidays = holidayData.filter(
      (holiday) => holiday.date === date
    );
    //console.log(`Found ${matchingHolidays.length}`, matchingHolidays);

    const trimmedHolidays = matchingHolidays.map((holiday) => ({
      type: "success",
      content: holiday.holiday_name.split("|").map((name) => name.trim()),
    }));

    return trimmedHolidays;
  };

  // const cellRender = (value) => {
  //   const listData = getListData(value);
  //   return (
  //     <ul className="events">
  //       {listData.map((item, index) => (
  //         item.content.map((name, subIndex) => (
  //           <li key={`${index}-${subIndex}`}
  //           onClick={() => {
  //             setModalOpen(true);
  //             setSelectedDate(value.format('YYYY-MM-DD'));
  //           }}
  //           >
  //             <Badge status={item.type} text={name} />
  //           </li>
  //         ))
  //       ))}
  //     </ul>
  //   );
  // };

  const cellRender = (value) => {
    const listData = getListData(value);
    return (
      <div
        onClick={() => {
          setModalOpen(true);
          setSelectedDate(value.format("YYYY-MM-DD"));
        }}
      >
        <ul className="events">
          {listData.map((item, index) =>
            item.content.map((name, subIndex) => (
              <li key={`${index}-${subIndex}`}>
                <Badge status={item.type} text={name} />
              </li>
            ))
          )}
        </ul>
      </div>
    );
  };

  const isMobile = window.innerWidth < 768;

  return (
    <>
      <ClientNavbarLayout />
      <Calendar cellRender={cellRender} className="mobile-calender" />

      {isMobile && (
        <AntModal
          title={`Holidays on ${selectedDate}`}
          open={isModalOpen}
          onCancel={() => setModalOpen(false)}
          footer={null}
          centered
        >
          {holidayData
            .filter((holiday) => holiday.date === selectedDate)
            .map((holiday, index) => (
              <div key={index}>
                {/* <p>Date: {selectedDate}</p>
                <p>Holidays:</p> */}
                <ul>
                  {holiday.holiday_name.split("|").map((name, subIndex) => (
                    <li key={subIndex}>
                      <Badge status="success" text={name.trim()} />
                    </li>
                  ))}
                </ul>
              </div>
            ))}
        </AntModal>
      )}
    </>
  );
};

export default HolidayCalender;
